import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, map, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UserState } from '../store';
import { UserRoleEnum } from '../../shared/enums/UserRoleEnum';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  private readonly unauthorizedUrl = '/unauthorized';

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const allowedRoles: UserRoleEnum[] = route.data?.rolesAllowed ?? [];

    return this.store.select(UserState.role).pipe(
      // Filter if role undefined
      filter(role => !!role),
      map(role => role !== undefined && allowedRoles.includes(role)),
      tap(res => {
        if (!res) {
          void this.router.navigate([this.unauthorizedUrl]);
        }
      })
    );
  }
}
